<template>
  <div>

    <div class="container"
         style="background: #FFFFFF;min-height: 100vh;">
      <div class="login_user">
        <img src="../../assets/images/logo.jpg"
             alt="">
        <!--<span v-if="wxuser">{{wxuser.uName?wxuser.uName:(wxuser.uUsername?wxuser.uUsername:'')}}</span>-->
      </div>
      <ul>
        <li class="require">
          <span class="require">姓名</span>
          <input type="text"
                 placeholder="请输入姓名"
                 v-model="name">
        </li>
        <li class="require"><span class="disStyle">手机号</span><input type="number"
                 placeholder="请输入手机号"
                 v-model="phone"
                 ref="mobile"></li>

        <li class="code require">
          <div>
            <span class="disStyle">验证码</span><input type="number"
                   placeholder="请输入验证码"
                   v-model="identify">
          </div>
          <button type="button"
                  @click="getCode(active)"
                  id="code">{{code}}</button>
        </li>
        <li>
          <span class="require">单位</span>
          <input type="text"
                 placeholder="请输入单位"
                 v-model="org"
                 ref="email">
        </li>
        <!--<li>-->
          <!--<span>职称</span>-->
          <!--<input type="text"-->
                 <!--placeholder="请输入职称"-->
                 <!--v-model="post"-->
                 <!--ref="email">-->
        <!--</li>-->
        <!--<li>-->
          <!--<span>邮箱</span>-->
          <!--<input type="text"-->
                 <!--placeholder="请输入邮箱"-->
                 <!--v-model="uMail"-->
                 <!--ref="email">-->
        <!--</li>-->
        <!--<li>-->
          <!--<span>地址</span>-->
          <!--<input type="text"-->
                 <!--placeholder="请输入地址"-->
                 <!--v-model="addr"-->
                 <!--ref="email">-->
        <!--</li>-->

        <div>
          <button class="sub_btn"
                  @click="submitUser">提交</button>
        </div>

      </ul>

    </div>

  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
import loginService from '../../plugin/extendFn/loginService';
export default {
  data () {
    return {
      pro: sessionStorage.getItem('pro'),
      wxuser: {},
      code: "获取验证码",
      name: '',
      identify: '',
      active: 1,
      org: "", // 单位
      post: '', // 职称
      phone: '', // 电话
      uMail: '', // 邮箱
      addr: '' // 地址

    }
  },
  props: {},
  watch: {
    phone (newValue, oldValue) {
      let obtn = document.getElementById('code');
      if (newValue.length > 11) {
        this.phone = newValue.substring(0, 11);
      }

      let reg = /^[1]([3-9])[0-9]{9}$/; //验证规则
      if (reg.test(this.phone)) {

        obtn.style.color = '#007EFF';
        this.$refs.mobile.style.borderColor = '#ccc'
      } else {

        obtn.style.color = '#666666';
        this.$refs.mobile.style.borderColor = 'red'
      }
    },

  },
  methods: {
    tabtype (type) {
      this.active = type;
      this.phone = '';
      this.identify = '';
      this.name = '';
    },

    submitUser () {

      if (this.name == '') {
        this.topTips('请输入姓名！');
        return false;
      }

      if (this.phone == '') {
        this.topTips('请输入手机号！');
        return false;
      }
      if (this.identify == '') {
        this.topTips('请输入验证码！');
        return false;
      }
      // if (this.org == '') {
      //   this.topTips('请输入单位！');
      //   return false;
      // }

      let params = {
        identify: this.identify,
        // login_fl: this.active == 1 ? 'phone' : 'mail',
        name: this.name,
        org: this.org,
        // uMail: this.uMail,
        // post: this.post,
        // addr: this.addr,
        id: this.wxuser ? (this.wxuser.uId ? this.wxuser.uId : '') : '',
      };
      if (this.active == 1) {
        params.phone = this.phone
      } else {
        params.uMail = this.uMail
      }
      this.$postHttp(AppSetting.baseUrl + '/student/update', params).then(async (res) => {
        // console.log(res);
        if (res.data.code == 0) {
          await loginService.setLoginUser(res.data.student)
          this.$router.go(-1);
          this.toast('登录成功！');
          setTimeout(() => {
            // window.history.go(-1);
          }, 2000)
        } else if (res.data.code == 2003) {
          this.topTips('验证码错误！');
        } else if (res.data.code == 2001) {
          this.topTips('验证码过期！');
        } else {
          this.topTips('绑定失败！');
        }
      })

    },
    getCode (type) {
      let data = '', url = '', msg = '';
      const obtn = document.getElementById('code');

      obtn.style.color = '#333333';
      if (type == 1) {
        if (!this.phone) {
          this.topTips('请输入正确的手机号！');
        }

        data = { phone: this.phone, type: 'LOGIN' }
        url = AppSetting.baseUrl + '/login/identify'
        msg = '发送成功，请查看短信'
      } else if (type == 2) {
        data = { mail: this.mail }
        url = AppSetting.baseUrl + '/login/mail/identify'
        msg = '发送成功，请到邮箱查看'
      }
      this.$postHttp(url, data).then((res) => {
        // console.log(res);
        if (res.data.code == 2007) {
          this.topTips('验证码发送失败');
        } else if (res.data.code == 0) {

          let num = 59;
          this.code = num + 's后重发';
          this.disable = true;
          let code = setInterval(() => {
            num--;
            this.code = num + 's后重发';
            if (num < 1) {
              this.disable = false;
              obtn.style.color = '#007EFF';
              this.code = '重新获取';
              clearInterval(code)
            }
          }, 1000)
          this.toast(msg);
        } else if (res.data.code == 2008) {
          this.topTips('此邮箱已被绑定!');
        }
      });
    },
    toRegister () {
      this.$router.push({
        name: "Register",
      })
    },
    toFind () {
      this.$router.push({
        name: "Findpass",
      })
    },
  },
  computed: {},
  async mounted () {
    this.wxuser =await loginService.getLoginUser()
  }
}
</script>
<style scoped lang="scss">
input {
  -webkit-appearance: none; /*去除input默认样式*/
}
.container {
  height: 100vh;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  background: #ffffff;
  .login_user {
    text-align: center;
    width: 7.5rem;

    display: flex;
    flex-direction: column;
    align-items: center;
    span {
      font-size: 0.4rem;
      font-weight: bold;
      color: #ffffff;
    }
    img {
      width: 2.5rem;
      height: 2.5rem;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      margin-bottom: 0.12rem;
      margin-top: 0.43rem;
    }
    margin-bottom: 0.75rem;
  }
  ul {
    padding: 0 0.75rem 0 0.73rem;
    font-size: 0.32rem;
    background: #ffffff;

    li {
      display: flex;
      margin-bottom: 0.2rem;
      align-items: center;
      border-bottom: 1px solid rgba(204, 204, 204, 1);
      &.require {
        position: relative;
        &::before {
          content: "*";
          color: #f56c6c;
          margin-right: 2px;
          font-size: 0.22rem;
          position: absolute;
          top: 0.16rem;
          left: -0.16rem;
        }
      }

      span {
        color: #333333;
        text-align: justify;
        letter-spacing: 0.46rem;
        text-justify: distribute-all-lines;
        display: inline-block;
        width: 1.6rem;
        margin-right: -0.3rem;
        font-size: 0.28rem;
        &.disStyle {
          letter-spacing: 0.1rem;
        }
      }
    }
    .code {
      input {
        width: 3rem;
        height: 0.7rem;
        background: #ffffff;
        // border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 5px;
        padding-left: 0.2rem;
        box-sizing: border-box;
      }
      button {
        margin-left: 0.3rem;

        height: 0.7rem;
        background: rgba(255, 255, 255, 1);
        // border: 1px solid rgba(204, 204, 204, 1);
        box-sizing: border-box;
        border-radius: 5px;
        font-size: 0.26rem;
        color: #666666;
        border: 0;
        outline: none;
      }
    }
    input {
      width: 4.6rem;
      height: 0.7rem;
      background: rgba(255, 255, 255, 1);
      // border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 5px;
      border: 0;
      padding: 0.1rem 0.2rem;
      box-sizing: border-box;

      outline: 0px;
      font-size: 0.26rem;
    }
    input::placeholder {
      font-size: 0.26rem;
      color: #999999;
    }
  }
  .findpass {
    color: #00468f;
  }
  .sub_btn {
    border: none;
    outline: none;
    width: 6rem;
    height: 0.9rem;
    background: linear-gradient(0deg, #00468f 0%, rgba(32, 174, 255, 1) 100%);
    border-radius: 5px;
    font-size: 0.36rem;
    color: #ffffff;
    margin-top: 0.89rem;
    margin-bottom: 0.2rem;
  }
}

.tab {
  text-align: right;
  font-size: 0.24rem;
  span {
    color: #00468f !important;
    text-align: left !important;
    text-align-last: left !important;
    margin-right: 0px !important;
    display: inline-block;
    min-width: 1.18rem !important;
  }
}
#code {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue